// extracted by mini-css-extract-plugin
export default {"searchFieldContainer":"SearchInput_searchFieldContainer__8t-uL","searchIcon":"SearchInput_searchIcon__-0C2D","focus":"SearchInput_focus__CsWg-"};